import { createStyles, makeStyles, Theme } from '@material-ui/core';

const avisoPagoComercialStyles = makeStyles((theme: Theme) =>
  createStyles({
    avisoCnt: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '2.125rem auto 0 auto',
      background: 'var(--gris-l96)',
      gap: '76px',
      borderRadius: '15px 15px 0 0',
      padding: '28px 22px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        minWidth: 'auto',
        padding: '24px 20px',
        maxWidth: '422px',
        gap: '24px',
      },
    },
    avisoCntFitContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '2.125rem auto 0 auto',
      background: 'var(--gris-l96)',
      borderRadius: '15px 15px 0 0',
      padding: '28px 32px',
      gap: '24px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        width: 'auto',
        minWidth: 'auto',
        padding: '28px 32px',
        maxWidth: '350px',
      },
    },
    infoErrorCnt: {
      alignItems: 'center',
      marginLeft: '-10px',
      width: '314px',
      [theme.breakpoints.down('sm')]: {
        marginLeft: '0',
        width: '100%',
        marginTop: '-16px',
      },
    },
    contenedorBoton: {
      display: 'flex',
      gap: '24px',
      maxWidth: '300px',
      marginLeft: '50px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginLeft: '0',
      },
    },
    seccionOficinaVirtual: {
      width: '100%',
      background: '#EAEBF0',
      borderRadius: '0 0 15px 15px',
      padding: '16px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        padding: '12px',
        maxWidth: '350px',
        margin: '0 auto',
      },
    },
    botonIr: {
      width: '100%',
      '& .MuiButton-label': {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        justifyContent: 'center',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    label: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '0.25rem',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        textAlign: 'center',
      },
    },
    info: {
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        textAlign: 'center',
      },
    },
    infoPendiente: {
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        textAlign: 'center',
      },
    },
    iconSuccess: {
      marginRight: '.5rem',
      '--icon-primary-dark': 'var(--secundario-azul-marino)',
      '--icon-primary-light': 'var(--verde-exito)',
    },
    iconError: {
      '--icon-primary-dark': 'var(--secundario-azul-marino)',
      '--icon-primary-light': 'var(--rojo-error)',
      [theme.breakpoints.down('sm')]: {
        marginRight: '0',
      },
    },
    contenedorMobile: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
      },
    },
    iconExport: {
      width: '16px',
      height: '16px',
    },
    pagadoIcono: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        marginBottom: 0,
      },
    },
    pagadoFecha: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
        width: '100%',
      },
    },
    pagadoMonto: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'flex-start',
        width: '100%',
      },
    },
    vencimientoEmision: {
      width: '82px',
      marginRight: '-24px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginRight: '0px',
      },
    },
    vencimiento: {
      width: '82px',
      marginRight: '-24px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginRight: '0px',
      },
    },
    sinInfo: {
      color: 'var(--gris-l43)',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    vencimientoMonto: {
      width: 'auto',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    vencimientoBoton: {
      marginLeft: '-28px',
      width: '190px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginLeft: '0px',
      },
    },
    vencimientoContenedor: {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%',
      },
    },
    verBoletaVencida: {
      display: 'flex',
      textDecoration: 'none',
      gap: '8px',
      [theme.breakpoints.down('sm')]: {},
    },
    verBoletaPendiente: {
      display: 'flex',
      textDecoration: 'none',
      gap: '8px',
    },

    lineaSeparadora: {
      height: '55px',
      border: '1px solid var(--gris-l83)',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    textoBoton: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '18px',
      color: 'var(--primario-morado)',
      flex: 'none',
      order: 1,
      flexGrow: 0,
    },
    textoOficinaVirtual: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontSize: '14px',
      lineHeight: '18px',
      textAlign: 'center',
      display: 'block',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
      },
    },
    textoParteUno: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: 'var(--gris-l3)',
      display: 'inline',
    },
    linkOficinaVirtual: {
      textDecoration: 'none',
      display: 'inline',
      '&:hover': {
        textDecoration: 'none',
      },
    },
    textoLinkOficinaVirtual: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '18px',
      color: 'var(--primario-morado)',
      textDecoration: 'none',
      display: 'inline',
      '&:hover': {
        textDecoration: 'none',
        color: 'var(--primario-morado)',
      },
    },
  })
);

export default avisoPagoComercialStyles;
